module.exports = __webpack_public_path__ + "static/payment-cards-accepted-1fd21e53d83cea170598ed982e0dccc8.jpg";